module.exports = __webpack_public_path__ + "img/8a52f41.png";